import { useSelector, useDispatch } from 'react-redux';
import { handleSelectMyShiftsBeginDate, handleSelectMyShiftsEndDate, getMyShifts } from '../actions';
import DateRangeSelector from './DateRangeSelector';
import EmployeeShifts from './EmployeeShifts';

const MyShifts = () => {
    const dispatch = useDispatch()
    const myShifts = useSelector(state => state.myShifts)
    return <div>
            <DateRangeSelector beginDate={myShifts.beginDate} endDate={myShifts.endDate} 
            onSelectBeginDate={date => {
                 dispatch(handleSelectMyShiftsBeginDate(date))
            }}
            onSelectEndDate={date => {
                dispatch(handleSelectMyShiftsEndDate(date))
            }}
            />
            <button onClick={()=> {
                dispatch(getMyShifts(myShifts.beginDate, myShifts.endDate))
            }}>Get Report</button>
            <p/>
            {myShifts.shifts.length > 0 ?
                 <EmployeeShifts employeeShifts={myShifts.shifts}/>:null
            }
    </div>

}

export default MyShifts